/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProblemRead } from './ProblemRead';
import {
    ProblemReadFromJSON,
    ProblemReadFromJSONTyped,
    ProblemReadToJSON,
    ProblemReadToJSONTyped,
} from './ProblemRead';

/**
 * Paginated response for problems list.
 * @export
 * @interface PaginatedProblemsResponse
 */
export interface PaginatedProblemsResponse {
    /**
     * List of problems
     * @type {Array<ProblemRead>}
     * @memberof PaginatedProblemsResponse
     */
    items: Array<ProblemRead>;
    /**
     * Total number of matching problems
     * @type {number}
     * @memberof PaginatedProblemsResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedProblemsResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedProblemsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedProblemsResponse interface.
 */
export function instanceOfPaginatedProblemsResponse(value: object): value is PaginatedProblemsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedProblemsResponseFromJSON(json: any): PaginatedProblemsResponse {
    return PaginatedProblemsResponseFromJSONTyped(json, false);
}

export function PaginatedProblemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedProblemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ProblemReadFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedProblemsResponseToJSON(json: any): PaginatedProblemsResponse {
    return PaginatedProblemsResponseToJSONTyped(json, false);
}

export function PaginatedProblemsResponseToJSONTyped(value?: PaginatedProblemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ProblemReadToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

